var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61342 6.47549C1.52262 6.33173 1.47723 6.25985 1.45182 6.14898C1.43273 6.06571 1.43273 5.93437 1.45182 5.8511C1.47723 5.74023 1.52262 5.66835 1.61341 5.52459C2.36369 4.3366 4.59693 1.33337 8.00027 1.33337C11.4036 1.33337 13.6369 4.3366 14.3871 5.52459C14.4779 5.66835 14.5233 5.74023 14.5487 5.8511C14.5678 5.93437 14.5678 6.06571 14.5487 6.14898C14.5233 6.25985 14.4779 6.33173 14.3871 6.47549C13.6369 7.66348 11.4036 10.6667 8.00027 10.6667C4.59693 10.6667 2.36369 7.66348 1.61342 6.47549Z",
    stroke: "#98A2B3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00027 8.00004C9.10484 8.00004 10.0003 7.10461 10.0003 6.00004C10.0003 4.89547 9.10484 4.00004 8.00027 4.00004C6.8957 4.00004 6.00027 4.89547 6.00027 6.00004C6.00027 7.10461 6.8957 8.00004 8.00027 8.00004Z",
    stroke: "#98A2B3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.c777466e098ca728436f9ea621605608.svg";
export { ForwardRef as ReactComponent };